/**
 * Password Criteria component renders requirement items and denotes if the criteria is met or not
 *
 * @module views/components/TagGroupForInput
 * @memberof -Common
 */
import './TagGroupForInput.scss';

import React from 'react';

import PropTypes from 'prop-types';

import InlineMessage from '@ulta/core/components/InlineMessage/InlineMessage';
import Text from '@ulta/core/components/Text/Text';
import { hasItems } from '@ulta/core/utils/array/array';

/**
 * Represents a Password Criteria component
 *
 * @method
 * @param {TagGroupForInputProps} props - React properties passed from composition
 * @returns TagGroupForInput
 */
export const TagGroupForInput = function( props ){
  const {
    value,
    validations,
    tagGroupHeading,
    tagGroupHeadingProps
  } = props;

  const headingProps = tagGroupHeadingProps || DEFAULT_TAG_GROUP_HEADING_PROPS;

  const configs = hasItems( validations ) ? validations : [];

  if( configs.length === 0 ){
    return null;
  }

  const messageTypes = [];
  if( value && value !== '' ){
    configs.map( validation => {
      messageTypes.push( value.match( validation.regex ) ? 'success' : 'failure' );
    } );
  }

  return (
    <div className='TagGroupForInput'>
      { tagGroupHeading &&
        <Text
          htmlTag={ headingProps.htmlTag }
          textStyle={ headingProps.textStyle }
        >
          { tagGroupHeading }
        </Text>
      }
      <ul>
        {
          configs.map( ( validation, index ) => {
            return (
              <li key={ `${Math.random()}-infomsg-list-${index}` }>
                <InlineMessage
                  messageType={ messageTypes[index] || 'info' }
                  message={ validation.message }
                  id={ `helper-${index}` }
                  iconSize='s'
                  iconDisplay={ messageTypes.length > 0 }
                />
              </li>
            );
          } )
        }
      </ul>
    </div>
  );
};

const DEFAULT_TAG_GROUP_HEADING_PROPS = {
  htmlTag: 'p',
  textStyle: 'body-2'
};

/**
 * Property type definitions
 * @typedef TagGroupForInputProps
 * @type {object}
 * @property {string} value - user inputted value that needs to be validated
 * @property {string} tagGroupHeading - password instruction heading
 * @property {array} validations - array of validation rules
 * @property {Object} tagGroupHeadingProps - object of tagGroupHeading props for text component
 *
 */
export const propTypes =  {
  value: PropTypes.string,
  tagGroupHeading: PropTypes.string,
  validations: PropTypes.array,
  tagGroupHeadingProps: PropTypes.object
};

TagGroupForInput.propTypes = propTypes;

export default TagGroupForInput;
